import { pick, assoc } from 'ramda';

import {
  TOGGLE_ELEMENT_INFO, UPDATE_CREATING_BOTSPEC, TOGGLE_MENU,
  UPDATE_VIEW_BOTSPEC_SETTINGS, UPDATE_VIEW_CONNECTION_PANEL, UPDATE_SHOW_EDITOR,
  NAMESPACE, UPLOADING_FILE_TO_S3, RESET_VISUALBUILDER,
} from './constants';

const initialState = () => ({
  showNodePanel: false,
  showEditor: false,
  showMenu: false,
  content: null,
  loadingChatbots: false,
  creatingChatbot: false,
  deletingChatbot: false,
  showDeleteModal: false,
  parsingSpec: false,
  showSettings: false,
  viewConnectionInfo: false,
  variables: [],
  editorError: '',
  uploadingFile: false,
});

const reducer = (state = initialState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_ELEMENT_INFO:
      return {
        ...state,
        ...pick(['showNodePanel', 'viewConnectionInfo', 'content'], payload),
      };
    case UPDATE_CREATING_BOTSPEC:
      return assoc('creatingChatbot', payload.value, state);
    case TOGGLE_MENU:
      return assoc('menuVisible', payload.value, state);
    case UPDATE_VIEW_BOTSPEC_SETTINGS:
      return assoc('showSettings', payload.value, state);
    case UPDATE_VIEW_CONNECTION_PANEL:
      return {
        ...state,
        ...pick(['viewConnectionInfo', 'infoVisible', 'content'], payload),
      };
    case UPDATE_SHOW_EDITOR:
      return assoc('showEditor', payload.value, state);
    case UPLOADING_FILE_TO_S3:
      return { ...state, uploadingFile: payload.uploading };
    case RESET_VISUALBUILDER:
      return initialState();
    default:
      return state;
  }
};

export default { [NAMESPACE]: reducer };
